export const cilInput = ["24 24","<path d='M22.125 4.5h-20.25c-0.621 0.001-1.124 0.504-1.125 1.125v3.75h1.5v-3.375h19.5v12h-19.5v-3.375h-1.5v3.75c0.001 0.621 0.504 1.124 1.125 1.125h20.25c0.621-0.001 1.124-0.504 1.125-1.125v-12.75c-0.001-0.621-0.504-1.124-1.125-1.125h-0z'></path><path d='M9.97 15.144l1.061 1.061 4.243-4.243-4.243-4.243-1.061 1.061 2.432 2.432h-11.652v1.5h11.652l-2.432 2.432z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-input.js
// module id = null
// module chunks = 